export const baseUrl="https://api.elitex.lvm.ai"

export const pricingUrl='https://apipricing.elitex.lvm.ai/api/Rate'